var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"maker-link",attrs:{"target":"_blank","rel":"noopener","href":"https://x.com/ben_makes_stuff"}},[_c('img',{attrs:{"src":"https://pbs.twimg.com/profile_images/1916569670314074112/X02_V5kF_400x400.jpg"}}),_c('p',[_vm._v("Made by @ben_makes_stuff")])])
}]

export { render, staticRenderFns }